import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { BnUsuarioService, Usuario} from '@bndes/bndes-ux4/bn-usuario';

@Component({
  selector: 'home',
  template: '',
  standalone: false
})
export class HomeComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private usuarioService: BnUsuarioService,
  ) {
  }

  ngOnInit(): void {

  }

}
